<template>
  <div class="mit-analytics-chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js/auto';

export default {
  name: 'MitAnalyticsChartBar',
  props: {
    chartData: { type: Object, required: true },
    title: { type: String, default: 'Occurrences' },
    labelX: { type: String, default: 'Metric' },
    labelY: { type: String, default: 'Count' }
  },
  data() {
    return {
      chartInstance: null,
      backgroundColors: [
        'rgba(25, 118, 210, 0.6)',
        'rgba(76, 175, 80, 0.6)',
        'rgba(255, 152, 0, 0.6)',
        'rgba(244, 67, 54, 0.6)',
        'rgba(156, 39, 176, 0.6)'
      ],
      borderColors: [
        '#1976d2',
        '#4caf50',
        '#ff9800',
        '#f44336',
        '#9c27b0'
      ]
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      const ctx = this.$refs.chartCanvas;
      if (!ctx) return;

      this.chartInstance = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.chartData.labels,
          datasets: [{
            label: this.labelY,
            data: this.chartData.values,
            backgroundColor: this.backgroundColors,
            borderColor: this.borderColors,
            borderWidth: 1
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            title: { display: true, text: this.title }
          },
          scales: {
            y: { beginAtZero: true, title: { display: true, text: this.labelY } },
            x: { title: { display: true, text: this.labelX } }
          }
        }
      });
    }
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
};
</script>

<style scoped>
.mit-analytics-chart-container {
  position: relative;
  height: 300px;
  width: 100%;
}
</style>